import adminRouter from "@/router/admin";
import store from "@/store";
import loginPage from "@/views/pages/login.vue";
import $ from "jquery";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

// import {
//   ROLE_ADMIN,
//   ROLE_ADMIN_CUSTOMER,
//   ROLE_CUSTOMER,
// } from "@/common/constant";
Vue.use(VueRouter);

const baseRouter: RouteConfig[] = [
  {
    path: "/login",
    name: "login",
    meta: {
      pageTitle: "成田養魚園管理者専用サイト",
      bodyClass: "mb__admin mb__login",
    },
    component: loginPage,
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("@/views/pages/logoutPage.vue"),
  },
];

const routes = [...baseRouter, ...adminRouter];

const router = new VueRouter({
  mode: "history",
  // base: process.env.NODE_ENV === "development" ? process.env.BASE_URL : "",
  routes,
});
router.beforeEach(async (to, from, next) => {
  if (to.name === "login" && localStorage.getItem("token")) {
    next({ name: "admin.default" });
  }

  if (!localStorage.getItem("token") && to.name !== "login") {
    next({ name: "login" });
  }

  if (
    // to.meta.allowRole
    // && !to.meta.allowRole.includes(store.state.Auth.role.name)
    to.meta.allowPermission &&
    !store.state.Auth.permissions.some((permission) =>
      to.meta.allowPermission.includes(permission.name),
    )
  ) {
    next({
      name: "forbidden",
    });
  }

  next();

  // const errorRouter = ["forbidden", "error", "notFound"];
  // if (from.name && from.name != to.name && !errorRouter.includes(to.name)) {
  //   let query = {};
  //   switch (to.name) {
  //     case "admin.admin-customers":
  //       query = store.state.Router.searchParameters
  //         ? store.state.Router.searchParameters.adminCustomer
  //         : {};
  //       break;
  //     case "admin.order-histories":
  //     case "admin-customer.order-histories":
  //       query = store.state.Router.searchParameters
  //         ? store.state.Router.searchParameters.orderHistory
  //         : {};
  //       break;
  //   }
  //   query = _.pickBy(query, (item) => item);
  // next({ name: to.name});
});

router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.pageTitle || "";
    document.body.setAttribute("class", to.meta.bodyClass || "");
    $("#menu_bar").removeClass("open");
  });
});
export default router;
